import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  BackGround,
  PaperLogin,
  ButtonLogin,
  DivForm,
  ImagemLogin,
  TextFieldLogin,
  LinkLogin,
  InputsContainer,
  DivText,
  CenterInputs,
  InputsContainerButtons,
} from "../login/styles";
import { useAuthContext } from "../../../contexts/auth-context";
import { Navigate, useNavigate } from "react-router-dom";
import { AiOutlineLock } from "react-icons/ai";
import { InputAdornment } from "@mui/material";
import { useFormik } from "formik";
import AuthService from "../../../services/auth-service";
import * as Yup from "yup";
import Toast from "../../../components/toast";
import ExceptionUtils from "../../../utils/ExceptionUtils";

interface IChangePassword {
  password: string;
  passwordConfirmation: string;
}

const AtualizarSenha = () => {
  const { isAuthenticated } = useAuthContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    form.validateForm(form.values).then((errors) => {
      Object.entries(errors).map((error) =>
        Toast.error(error[1])
      );
    });
  };

  const form = useFormik({
    initialValues: {
      password: "",
      passwordConfirmation: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Senha: Campo obrigatório")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
          "A senha deve possuir mais de 8 caracteres, contendo no mínimo uma letra maiúscula, uma letra minuscula e um numeral."
        ),
      passwordConfirmation: Yup.string()
        .oneOf([Yup.ref("password"), undefined], "Senhas não coincidem")
        .required("Confirmação de Senha: Campo obrigatório"),
    }),
    onSubmit: async (values: IChangePassword) => {
      try {
        setLoading(true);
        const token = searchParams.get("token");
        if (token) {
          const updated = await AuthService.updatePassword(token, values.password);
          if (updated) {
            Toast.success("Senha atualizada com sucesso!");
            navigate("/login");
            return;
          }
        }
        throw new Error("Token inválido");
      } catch (e) {
        ExceptionUtils.defaultExceptionHandler(e);
      } finally {
        setLoading(false);
      }
    },
    validateOnChange: false,
  });

  if (isAuthenticated) return <Navigate replace to="/dashboard" />;
  return (
    <>
      <BackGround>
        <PaperLogin>
          <ImagemLogin />
          <DivForm onSubmit={form.handleSubmit}>
            <DivText>
              <CenterInputs>
                <InputsContainer>
                  <TextFieldLogin
                    fullWidth
                    name={"password"}
                    id={"password"}
                    label="Senha"
                    variant="standard"
                    type={"password"}
                    value={form.values.password}
                    onChange={form.handleChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AiOutlineLock fontSize={25} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextFieldLogin
                    fullWidth
                    name={"passwordConfirmation"}
                    id={"passwordConfirmation"}
                    label="Confirmação de Senha"
                    variant="standard"
                    type={"password"}
                    value={form.values.passwordConfirmation}
                    onChange={form.handleChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AiOutlineLock fontSize={25} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </InputsContainer>
              </CenterInputs>
              <InputsContainerButtons>
                <ButtonLogin
                  type={"submit"}
                  onClick={validateForm}
                  disabled={loading}
                >
                  Recuperar Senha
                </ButtonLogin>
                <LinkLogin onClick={() => navigate("/login")}>Voltar</LinkLogin>
              </InputsContainerButtons>
            </DivText>
          </DivForm>
        </PaperLogin>
      </BackGround>
    </>
  );
};

export default AtualizarSenha;
